import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "56106761-a24e-459f-96b2-f21283eb94d6",
  publicId: "30",
  name: "Auditory illusions",
  difficulty: 2,
  contentTypes: { audio: true, interactive: false, video: true },
  body: [principle01, principle02, principle03, task01, task02],
};

export default lesson;
